'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var api = /*#__PURE__*/Object.freeze({
    __proto__: null,
    get init () { return init; },
    get tag () { return tag; },
    get consent () { return consent; },
    get user () { return user; },
    get data () { return data; },
    get getData () { return getData; },
    get keys () { return keys; },
    get getUserId () { return getUserId; }
});

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

const getMessage = (error) => {
    if (error instanceof Error) {
        return error.message;
    }
    if (typeof error === 'string') {
        return error;
    }
    try {
        return JSON.stringify(error);
    }
    catch (_a) {
        return error;
    }
};
const log = (data) => {
    console.log('[EdgeTag]', getMessage(data));
};
const error = (data) => {
    console.error('[EdgeTag]', getMessage(data));
};

let endpointUrl = '';
const generateUrl = (path) => {
    const endpoint = getUrl();
    if (!endpoint) {
        log('URL is not valid');
        return '';
    }
    return `${endpoint}${path}`;
};
const getUrl = () => {
    return endpointUrl;
};
const setUrl = (url) => {
    if (url == null) {
        return;
    }
    endpointUrl = url;
};
const getTagURL = () => {
    return generateUrl('/tag');
};
const getInitURL = () => {
    return generateUrl('/init');
};
const getConsentURL = () => {
    return generateUrl('/consent');
};
const getUserURL = () => {
    return generateUrl('/user');
};
const getDataURL = () => {
    return generateUrl(`/data`);
};
const getGetDataURL = (keys) => {
    return generateUrl(`/data?keys=${encodeURIComponent(keys.join(','))}`);
};
const getKeysURL = () => {
    return generateUrl(`/keys`);
};

let allowedProvider = [];
let initialized = false;
let consentDisabled = false;
const providersPackages = {};
const setPreferences = (preferences) => {
    var _a;
    if (!preferences) {
        return false;
    }
    if (!preferences.edgeURL) {
        error('Please provide URL for EdgeTag');
        return false;
    }
    consentDisabled = !!preferences.disableConsentCheck;
    (_a = preferences.providers) === null || _a === void 0 ? void 0 : _a.forEach((provider) => {
        if (!provider.name) {
            return;
        }
        providersPackages[provider.name] = provider;
    });
    try {
        if (window && Array.isArray(window.edgetagProviders)) {
            window.edgetagProviders.forEach((provider) => {
                if (!provider.name) {
                    return;
                }
                providersPackages[provider.name] = provider;
            });
        }
    }
    catch (_b) {
        // do nothing
    }
    setUrl(preferences.edgeURL);
    return true;
};
const isConsentDisabled = () => consentDisabled;
const getProvidersPackage = () => providersPackages;
const isInitialized = () => initialized;
const setInitialized = () => {
    initialized = true;
};
const getAllowedProviders = () => allowedProvider;
const setAllowedProviders = (providers) => {
    allowedProvider = providers;
};

const checkConsent = (providers) => {
    if (isConsentDisabled()) {
        return true;
    }
    const consent = getConsent();
    if (!consent) {
        return false;
    }
    const consentLength = Object.keys(consent).length;
    if (!consentLength || (consentLength === 1 && consent['all'] === false)) {
        return false;
    }
    const providersLength = Object.keys(providers || {}).length;
    if (!providers ||
        providersLength === 0 ||
        (providersLength === 1 && providers['all'])) {
        return (Object.values(consent).find((isAllowed) => isAllowed) || false);
    }
    for (const [key, value] of Object.entries(providers)) {
        if (value === false || consent[key] === false) {
            continue;
        }
        // we have consent
        if (consent[key] ||
            (consent['all'] === true && consent[key] === undefined)) {
            // we have provider
            if (value || (providers['all'] && providers[key] === undefined)) {
                return true;
            }
        }
    }
    return false;
};
const getUserAgent = () => {
    try {
        const nav = navigator;
        return nav.userAgent;
    }
    catch (_a) {
        return '';
    }
};
const getReferrer = () => {
    let referrer = '';
    try {
        const referrerUrl = new URL(document.referrer);
        if (referrerUrl.host !== window.location.host) {
            referrer = referrerUrl.href;
        }
        return referrer;
    }
    catch (error) {
        return referrer;
    }
};
const getPageUrl = () => {
    try {
        return window.location.href;
    }
    catch (_a) {
        return '';
    }
};
const getSearch = () => {
    try {
        return window.location.search;
    }
    catch (_a) {
        return '';
    }
};
const getPageTitle = () => {
    try {
        return document.title;
    }
    catch (_a) {
        return '';
    }
};
const isProviderIncluded = (providers, providerValue) => {
    return (providerValue || (providers['all'] === true && providerValue === undefined));
};
const allowTag = (providers) => {
    if (!checkConsent(providers)) {
        return false;
    }
    const providersLength = Object.values(providers || {}).length;
    if (!providers || providersLength === 0) {
        return true;
    }
    const allProviders = getAllowedProviders();
    const allProvidersLength = Object.keys(allProviders || {}).length;
    if (allProvidersLength === 0) {
        return true;
    }
    for (const provider of allProviders) {
        if (isProviderIncluded(providers, providers[provider])) {
            return true;
        }
    }
    return false;
};
const allowProviders = (providers) => {
    if (!providers || Object.keys(providers).length === 0 || providers['all']) {
        return true;
    }
    const allowedProvider = getAllowedProviders();
    if (allowedProvider && allowedProvider.length > 0) {
        let found = false;
        Object.entries(providers).forEach(([key, value]) => {
            if (!value) {
                return;
            }
            if (allowedProvider.includes(key)) {
                found = true;
            }
        });
        return found;
    }
    return true;
};
const allowProvider = (providerId) => {
    if (!providerId) {
        return true;
    }
    const allowedProvider = getAllowedProviders();
    if (allowedProvider && allowedProvider.length > 0) {
        return allowedProvider.includes(providerId);
    }
    return true;
};
const allowProviderWithConsent = (providers, providerId) => {
    if (!allowProvider(providerId)) {
        return false;
    }
    if (!checkConsent(providers)) {
        return false;
    }
    if (providers && Object.keys(providers).length) {
        if (!isProviderIncluded(providers, providers[providerId])) {
            return false;
        }
    }
    return true;
};

const tagStorage = 'edgeTag';
const consentKey = 'consent';
const keyPrefix = `_worker`;
const cookieKey = 'tag_user_id';

const initKey = `${keyPrefix}Store`;
const saveDataPerKey = (persistType, provider, value, key) => {
    const storage = getData$1(persistType);
    if (!storage['data']) {
        storage['data'] = {};
    }
    if (!storage['data'][provider]) {
        storage['data'][provider] = {};
    }
    storage['data'][provider][key] = value;
    saveData(persistType, storage);
};
const savePerKey = (persistType, provider, value, key) => {
    const storage = getData$1(persistType);
    if (!storage[provider]) {
        storage[provider] = {};
    }
    storage[provider][key] = value;
    saveData(persistType, storage);
};
const getDataPerKey = (persistType, provider, key) => {
    const storage = getData$1(persistType);
    if (!storage[provider]) {
        return undefined;
    }
    return storage[provider][key];
};
const saveData = (persistType, value, key = initKey) => {
    if (persistType === 'session') {
        saveSession(value, key);
        return;
    }
    saveLocal(value, key);
};
const getData$1 = (persistType, key = initKey) => {
    if (persistType === 'session') {
        return getSession(key);
    }
    return getLocal(key);
};
const saveKV = (data) => {
    let currentSession = getData$1('session');
    if (!currentSession) {
        currentSession = {};
    }
    if (!currentSession['kv']) {
        currentSession['kv'] = {};
    }
    currentSession['kv'] = Object.assign(Object.assign({}, currentSession['kv']), data);
    saveData('session', currentSession);
};
const saveLocal = (value, key) => {
    try {
        if (!localStorage) {
            return;
        }
        localStorage.setItem(key, JSON.stringify(value));
    }
    catch (_a) {
        log('Local storage not supported.');
    }
};
const getLocal = (key) => {
    try {
        if (!localStorage) {
            return {};
        }
        const data = localStorage.getItem(key);
        if (!data) {
            return {};
        }
        return JSON.parse(data) || {};
    }
    catch (_a) {
        return {};
    }
};
const saveSession = (value, key) => {
    try {
        if (!sessionStorage) {
            return;
        }
        sessionStorage.setItem(key, JSON.stringify(value));
    }
    catch (_a) {
        log('Session storage not supported.');
    }
};
const getSession = (key) => {
    try {
        if (!sessionStorage) {
            return {};
        }
        const data = sessionStorage.getItem(key);
        if (!data) {
            return {};
        }
        return JSON.parse(data) || {};
    }
    catch (_a) {
        return {};
    }
};

const encodeString = (name) => {
    if (typeof btoa === 'undefined') {
        return Buffer.from(name).toString('base64');
    }
    return btoa(name);
};
const getBasicRandomNumber = () => {
    return parseInt((Math.random() * 10000000000).toString(), 10);
};
const generateUUID = () => {
    let id = '';
    try {
        id = crypto.randomUUID();
        if (!id) {
            const array = new Uint32Array(20);
            const numbers = crypto.getRandomValues(array);
            for (let i = 0; i < 5; i++) {
                const y = i * 3;
                if (i !== 0) {
                    id += '-';
                }
                const sum = numbers[y + 1] + numbers[y + 2] + numbers[y + 3];
                id += sum.toString();
            }
        }
    }
    catch (_a) {
        id = `${getBasicRandomNumber()}-${getBasicRandomNumber()}-${getBasicRandomNumber()}-${getBasicRandomNumber()}-${getBasicRandomNumber()}`;
        console.log('[EdgeTag] Crypto module not found');
    }
    return id;
};
const generateEventId = (name) => {
    let time = Date.now().toString();
    if (typeof performance !== 'undefined' &&
        typeof performance.now === 'function') {
        const perf = performance.now();
        if (perf) {
            time = perf.toFixed(4);
        }
    }
    return `${encodeString(name)}-${generateUUID()}-${time}`;
};

const getCookieValue = (key) => {
    try {
        if (!document || !document.cookie) {
            return '';
        }
        const name = `${key}=`;
        const decodedCookie = decodeURIComponent(document.cookie);
        const ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return '';
    }
    catch (_a) {
        return '';
    }
};

let initUserId = '';
const handleGetUserId = () => {
    if (initUserId) {
        return initUserId;
    }
    return getCookieValue(cookieKey);
};
const setUserId = (userId) => {
    initUserId = userId;
};

const beacon = (url, payload) => {
    try {
        let blob;
        if (payload) {
            blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
        }
        return navigator.sendBeacon(url, blob);
    }
    catch (e) {
        return Promise.reject(new Error('Beacon not supported.'));
    }
};
const ajax = (method, url, payload) => __awaiter(void 0, void 0, void 0, function* () {
    return yield fetch(url, {
        method,
        headers: {
            'Content-type': 'application/json; charset=utf-8',
            Accept: 'application/json; charset=utf-8',
            EdgeTagUserId: handleGetUserId(),
        },
        body: JSON.stringify(payload),
        credentials: 'include',
    })
        .then((response) => response.json().then((data) => ({ status: response.status, body: data })))
        .then((data) => {
        if (data.status < 200 || data.status >= 300) {
            return Promise.reject(new Error(`Request failed with code ${data.status}: ${JSON.stringify(data.body)}`));
        }
        return Promise.resolve(data.body);
    })
        .catch((error) => {
        return Promise.reject(new Error(error));
    });
});
const getStandardPayload = (payload) => {
    const data = Object.assign({ pageUrl: getPageUrl(), pageTitle: getPageTitle(), userAgent: getUserAgent(), referrer: getReferrer(), search: getSearch(), sdkVersion: "0.10.4"  }, (payload || {}));
    let storage = {};
    const session = getData$1('session');
    if (session) {
        storage = Object.assign(Object.assign({}, storage), session);
    }
    const local = getData$1('local');
    if (local) {
        storage = Object.assign(Object.assign({}, storage), local);
    }
    data.storage = storage;
    return data;
};
function postRequest(url, data, options) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!url) {
            return Promise.reject(new Error('URL is empty.'));
        }
        const payload = getStandardPayload(data);
        if (options && options.method === 'beacon') {
            return Promise.resolve(beacon(url, payload));
        }
        return yield ajax('POST', url, payload);
    });
}
function getRequest(url, options) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!url) {
            return Promise.reject(new Error('URL is empty.'));
        }
        if (options && options.method === 'beacon') {
            return {
                result: Promise.resolve(beacon(url)),
            };
        }
        return yield ajax('GET', url);
    });
}

let memoryConsent;
const saveConsent = (consent) => {
    setConsent(consent);
    savePerKey('local', tagStorage, consent, consentKey);
};
const handleConsent = (consent) => {
    const payload = {
        consentString: consent,
    };
    saveConsent(consent);
    postRequest(getConsentURL(), payload).catch(error);
};
const setConsent = (newConsent) => {
    memoryConsent = newConsent;
};
const getConsent = () => {
    const storageConsent = getDataPerKey('local', tagStorage, consentKey);
    if (storageConsent) {
        return storageConsent;
    }
    return memoryConsent;
};

const manifestVariables = {};
const addProviderVariable = (name, variables) => {
    manifestVariables[name] = variables;
};
const getProviderVariables = (name) => manifestVariables[name] || {};

let stubs = [];
const addStubs = (newStubs) => {
    stubs = [...stubs, ...newStubs];
};
const addStub = (stub) => {
    stubs.push(stub);
};
const processStubs = () => {
    try {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        stubs.forEach((stub) => api[stub.name](...(stub.arguments || [])));
        stubs = [];
    }
    catch (e) {
        error(e);
    }
};

const sendTag = ({ eventName, eventId, data, providerData, providers, options, }) => {
    if (!allowProviders(providers)) {
        log('Provider is not allowed.');
        return;
    }
    const payload = {
        eventName,
        eventId,
        timestamp: Date.now(),
        data,
        providerData,
    };
    if (providers) {
        payload.providers = providers;
    }
    postRequest(getTagURL(), payload, options).catch(error);
};
const handleTag = (eventName, data = {}, providers, options) => {
    if (!isInitialized()) {
        addStub({
            name: 'tag',
            arguments: [eventName, data, providers, options],
        });
        return;
    }
    if (!allowProviders(providers)) {
        log('Provider is not allowed.');
        return;
    }
    if (!allowTag(providers)) {
        log('Consent is missing.');
        return;
    }
    let eventId = data['eventId'];
    if (!eventId) {
        eventId = generateEventId(eventName);
    }
    const providerPackages = getProvidersPackage();
    const userId = handleGetUserId();
    const providerData = {};
    if (providerPackages) {
        Object.values(providerPackages).forEach((pkg) => {
            if (!pkg || !pkg.tag || !allowProviderWithConsent(providers, pkg.name)) {
                return;
            }
            const result = pkg.tag({
                userId,
                eventName,
                eventId,
                data,
                sendTag,
                manifestVariables: getProviderVariables(pkg.name),
            });
            if (result) {
                providerData[pkg.name] = result;
            }
        });
    }
    sendTag({
        eventName,
        eventId,
        data,
        providerData,
        providers,
        options,
    });
};

const handleData = (data, providers, options) => {
    if (!data || Object.keys(data).length === 0) {
        error('Provide data for data API.');
        return;
    }
    saveKV(data);
    const providerPackages = getProvidersPackage();
    const userId = handleGetUserId();
    if (providerPackages) {
        Object.values(providerPackages).forEach((pkg) => {
            if (!pkg || !pkg.user || !allowProviderWithConsent(providers, pkg.name)) {
                return;
            }
            pkg.user({
                userId,
                data,
                manifestVariables: getProviderVariables(pkg.name),
            });
        });
    }
    postRequest(getDataURL(), { data }, options).catch(error);
};

const saveDataToEdge = (key, value, provider) => {
    if (!value) {
        return;
    }
    if (typeof value !== 'string') {
        try {
            value = JSON.stringify(value);
        }
        catch (_a) {
            log('Error stringify value.');
            return;
        }
    }
    handleData({ [`${provider}::${key}`]: value });
};
const handleCaptureQuery = (provider, key, persistType) => {
    try {
        if (!window) {
            return;
        }
    }
    catch (_a) {
        return;
    }
    const params = new URLSearchParams(window.location.search);
    if (!params || !params.get(key)) {
        return;
    }
    const data = params.get(key);
    if (!data) {
        return;
    }
    if (persistType === 'edge') {
        saveDataToEdge(key, data, provider);
        return;
    }
    saveDataPerKey(persistType, provider, data, key);
};
const handleCaptureStorage = (provider, key, persistType, location) => {
    let data;
    try {
        switch (location) {
            case 'cookie': {
                data = getCookieValue(key);
                break;
            }
            case 'local': {
                data = localStorage.getItem(key);
                break;
            }
            case 'session': {
                data = sessionStorage.getItem(key);
            }
        }
    }
    catch (_a) {
        return;
    }
    if (!data) {
        return;
    }
    if (persistType === 'edge') {
        saveDataToEdge(key, data, provider);
        return;
    }
    saveDataPerKey(persistType, provider, data, key);
};
const handleCapture = (provider, params) => {
    params.forEach((param) => {
        switch (param.type) {
            case 'query': {
                handleCaptureQuery(provider, param.key, param.persist);
                break;
            }
            case 'storage': {
                handleCaptureStorage(provider, param.key, param.persist, param.location);
                break;
            }
        }
    });
};

const handleGetData = (keys, callback) => {
    if (!keys || keys.length === 0) {
        error('Provide keys for get data API.');
        return;
    }
    getRequest(getGetDataURL(keys))
        .then((result) => {
        callback((result === null || result === void 0 ? void 0 : result.result) || {});
    })
        .catch(error);
};

const handleManifest = (manifest) => {
    const providerPackages = getProvidersPackage();
    const userId = handleGetUserId();
    setAllowedProviders(manifest.map((provider) => provider.package));
    manifest.forEach((provider) => {
        addProviderVariable(provider.package, provider.variables);
        if (provider.rules) {
            Object.entries(provider.rules).forEach(([name, recipe]) => {
                switch (name) {
                    case 'capture': {
                        handleCapture(provider.package, recipe);
                        return;
                    }
                }
            });
        }
        if (providerPackages) {
            const pkg = providerPackages[provider.package];
            if (pkg && pkg.init && allowProvider(pkg.name)) {
                const initData = {
                    userId,
                    manifest: provider,
                    sendTag,
                    sendEdgeData: handleData,
                    getEdgeData: handleGetData,
                    keyName: `${keyPrefix}Store`,
                };
                pkg.init(initData);
            }
        }
    });
    setInitialized();
    processStubs();
};

const handleInit = (preferences) => {
    const success = setPreferences(preferences);
    if (!success) {
        return;
    }
    if (preferences.afterManifestEvents) {
        addStubs(preferences.afterManifestEvents);
    }
    const url = new URL(getInitURL());
    if (preferences.disableConsentCheck) {
        url.searchParams.set('consentDisabled', 'true');
        saveConsent({ all: true });
    }
    if (preferences.userId) {
        setUserId(preferences.userId);
        url.searchParams.set('userId', preferences.userId);
    }
    getRequest(url.href)
        .then((result) => {
        if (!result) {
            log('Initialization failed');
            return;
        }
        handleManifest(result.result);
    })
        .catch(error);
};

const handleUser = (key, value, providers, options) => {
    if (!key || !value) {
        error('Key or Value is missing in user API.');
        return;
    }
    saveKV({
        [key]: value,
    });
    const providerPackages = getProvidersPackage();
    const userId = handleGetUserId();
    if (providerPackages) {
        Object.values(providerPackages).forEach((pkg) => {
            if (!pkg || !pkg.user || !allowProviderWithConsent(providers, pkg.name)) {
                return;
            }
            pkg.user({
                userId,
                data: { [key]: value },
                manifestVariables: getProviderVariables(pkg.name),
            });
        });
    }
    postRequest(getUserURL(), {
        key,
        value,
    }, options).catch(error);
};

const handleKeys = (callback) => {
    getRequest(getKeysURL())
        .then((result) => {
        callback((result === null || result === void 0 ? void 0 : result.result) || []);
    })
        .catch(error);
};

const init = (preferences) => {
    handleInit(preferences);
};
const tag = (name, data, providers, options) => {
    handleTag(name, data, providers, options);
};
const consent = (consent) => {
    handleConsent(consent);
};
const user = (key, value, providers, options) => {
    handleUser(key, value, providers, options);
};
const data = (data, providers, options) => {
    handleData(data, providers, options);
};
const getData = (keys, callback) => {
    handleGetData(keys, callback);
};
const keys = (callback) => {
    handleKeys(callback);
};
const getUserId = () => {
    return handleGetUserId();
};

exports.consent = consent;
exports.data = data;
exports.getData = getData;
exports.getUserId = getUserId;
exports.init = init;
exports.keys = keys;
exports.tag = tag;
exports.user = user;
